import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, catchError, throwError, BehaviorSubject } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { environment } from '../../environments/environment';
import { CartService } from '../services/cart.service';

interface JwtPayload {
  exp: number;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })

export class AuthService {

  private loggedIn = new BehaviorSubject<boolean>(false);
  private userRole = new BehaviorSubject<string | null>(null);

  loggedIn$ = this.loggedIn.asObservable();
  userRole$ = this.userRole.asObservable();

  private baseUrl = environment.apiBaseUrl +'/api/auth'; // adjust backend URL

  constructor(private http: HttpClient, private cartService: CartService) { }

  login(credentials: { username: string; password: string }): Observable<any> {
    //return this.http.post(`${this.baseUrl}/login`, credentials);
    return this.http.post<any>(`${this.baseUrl}/login`, credentials).pipe(
      tap(res => {
        // 👇 optional: handle side effects
        if (res && res.token) {
          localStorage.setItem('token', res.token);

          const decodedToken: any = jwtDecode(res.token);
          localStorage.setItem('userId', decodedToken?.userId); // or whatever field carries the userId
          localStorage.setItem('role', this.getUserRole() ?? '');

          const currentTime = Math.floor(Date.now() / 1000);
          //If token expired
          if (decodedToken.exp < currentTime) {
            this.logout();
          }
          else {
            this.cartService.refreshCartCount();
          }

          this.loggedIn.next(true);
          this.userRole.next(localStorage.getItem('role'));
        }
      }),
      catchError(error => {
        console.error('Login failed:', error);
        return throwError(() => error);
      })
    );
  }

  logout(): void {
    localStorage.clear();
    this.loggedIn.next(false);
    this.userRole.next(null);
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    if (token) {
      this.loggedIn.next(true);
      this.userRole.next(role);
    }
    return !!token;
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  register(data: { username: string; email: string; password: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/register`, data);
  }

  getUserRole(): string | null {
    const token = this.getToken();
    if (!token) return null;
    const decoded: any = jwtDecode(token);
    return decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  }

  //getUserRole(): string {
  //  const token = localStorage.getItem('jwtToken');
  //  if (!token) return '';

  //  const payload = JSON.parse(atob(token.split('.')[1])); // decode JWT payload
  //  return payload['role'] || '';
  //}


  isVendor(): boolean {
    return this.getUserRole() === 'Vendor';
  }

  isAdmin(): boolean {
    return this.getUserRole() === 'Admin';
  }

  isTokenExpired(): boolean {
    const token = localStorage.getItem('token');
    if (!token) return true;

    try {
      const decoded = jwtDecode<JwtPayload>(token);
      const currentTime = Math.floor(Date.now() / 1000); // in seconds
      return decoded.exp < currentTime;
    } catch (e) {
      return true; // invalid token
    }
  }
}
